import { render, staticRenderFns } from "./InvoiceToBeReviewed.vue?vue&type=template&id=bd6e3918&scoped=true"
import script from "./InvoiceToBeReviewed.vue?vue&type=script&lang=js"
export * from "./InvoiceToBeReviewed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6e3918",
  null
  
)

export default component.exports